import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const PreQualifyPage = lazy(() => import('../pages/pre-qualify/page'));
const BookingPage = lazy(() => import('../pages/booking/page'));
const CallBookedPage = lazy(() => import('../pages/call-booked/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const DashboardLoginPage = lazy(() => import('../pages/dashboard/login/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/pre-qualify',
    element: <PreQualifyPage />,
  },
  {
    path: '/booking',
    element: <BookingPage />,
  },
  {
    path: '/call-booked',
    element: <CallBookedPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/dashboard/login',
    element: <DashboardLoginPage />,
  },
  {
    path: '/dashboard',
    element: <DashboardPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;